import * as React from "react";
import range from "lodash/range";
import moment from "moment";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Select, InputDescription } from "components/common";
const TimeSelect = ({ id, required = false }) => {
  const { t } = useTranslation("enterprise_report");
  const time = moment().minutes(0);
  const hours = range(0, 24).map((hour) => {
    const formattedTime = time.hours(hour).format("HH:mm");
    return { value: formattedTime, label: formattedTime };
  });
  return /* @__PURE__ */ React.createElement(Field, { name: id }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      onBlur,
      onChange: (newValue) => onChange({
        target: { value: newValue, name }
      }),
      options: hours,
      inputId: name,
      placeholder: t("time_select.placeholder"),
      required,
      value
    }
  ), error && touched && /* @__PURE__ */ React.createElement(InputDescription, { error, className: "no-bm" })));
};
export default TimeSelect;
